import {
  NativeResources,
  ResourceVulnerabilities,
  RiskContextResponse,
  SunburstDashboard,
} from '@ariksa/inventory-core/api';
import { AlertSeverityInitializer } from '@ariksa/notification';
import { IPagedQueryState } from 'services/utils/PagedQueryState';
import { IQueryState } from 'services/utils/QueryState';
import {
  ContainerInfo,
  InstanceSummary,
  Vulnerability,
  VulnerabilityBySeverityDashboard,
  VulnerabilityDashboardBySources,
  VulnerabilityPatchRecommendationResource,
  VulnerabilityPrioritization,
  VulnerablePackage,
} from 'services/Vulnerability/types';

import { PrioritizationFlow } from 'api/scan-vault/prioritizationFlow';
import { Sorted } from 'components/DataDisplay/NewTable/types';
import { ButtonGroupItem } from 'components/DataEntry';

export const VulnerabilityType = {
  Open: 'open',
  Resolved: 'resolved',
};

export interface vulnerabilityState {
  useVulnerabilityV3: boolean;
  resourceType: string;
  openVulnerabilitiesBySeverity: IQueryState<any>;
  resolvedVulnerabilitiesBySeverity: IQueryState<any>;
  vulnerabilitiesBySources: IQueryState<VulnerabilityDashboardBySources>;
  vulnerabilitiesBySeverityCounts: IQueryState<VulnerabilityBySeverityDashboard>;
  hostsWithOpenVulnerabilities: IQueryState<any>;
  hostsWithResolvedVulnerabilities: IQueryState<any>;
  hostsWithOpenVulnerabilitiesByType: IQueryState<any>;
  hostsWithResolvedVulnerabilitiesByType: IQueryState<any>;
  vulnerabilities: IPagedQueryState<any>;
  packageVulnerabilities: IQueryState<VulnerablePackage[]>;
  patchablePackages: IQueryState<VulnerablePackage[]>;
  cveHosts: IPagedQueryState<any>;
  cves: IPagedQueryState<Record<string, any>[]>;
  containers: IQueryState<ContainerInfo[]>;
  containerVulnerability: IQueryState<any>;
  searchTerm: string;
  vulnerabilityType: string;
  sort: Sorted;
  cveHostsRiskContext: IQueryState<Record<string, RiskContextResponse[]>>;
  riskContext: IQueryState<Record<string, RiskContextResponse[]>>;
  cveHostsVulnerabilities: Record<string, IQueryState<any>>;
  publishedAt: Record<string, any>;
  filters: Record<string, any>;
  cveDetails: IQueryState<any>;
  vulnerabilityPrioritization: IQueryState<VulnerabilityPrioritization>;
  prioritizationFlow: IQueryState<PrioritizationFlow>;
  vulnerableImages: IQueryState<SunburstDashboard>;

  resourceInsight: IQueryState<any>;
  resourceDetails: IQueryState<any>;
  resourceAlertCount: IQueryState<AlertSeverityInitializer>;
  resourceVulnerabilities: IPagedQueryState<Vulnerability[]>;
  resourceVulnerabilityCount: IQueryState<ResourceVulnerabilities>;
  resourceVulnerabilitySummary: IQueryState<InstanceSummary>;
  ecrImages: IPagedQueryState<any>;
  downloadReport: IQueryState<any>;
  ecrImageContainers: IQueryState<ContainerInfo[]>;
  containerRiskContext: IQueryState<Record<string, RiskContextResponse[]>>;
  patchRecommendations: IQueryState<VulnerabilityPatchRecommendationResource>;
}

export const CONTAINER_ON_VIRTUAL_MACHINE =
  NativeResources.Ec2Instance + '_Container';

export type ContainerState = vulnerabilityState;

export interface VulnerabilityChartProps {
  showResolved?: boolean;
  cumulative?: boolean;
  severities: IQueryState<any>;
  chartType: ButtonGroupItem;
  updateValue: (value: ButtonGroupItem) => void;
}

export const VulnerabilityViewByTabs = {
  Resource: 'resource',
  CVE: 'cve',
  Package: 'package',
};
